var blueimp = require('blueimp-md5');

module.exports = blueimp.md5 || blueimp;
